<template>
  <v-app>
    <Snackbar></Snackbar>
    <div class="app-loader" v-if="isAccountsFetchWaiting && !activeAccount">
      <span class="app-loader__message">Loading your accounts...</span>
      <v-progress-circular
        class="mx-auto"
        :size="70"
        :width="7"
        indeterminate
      ></v-progress-circular>
    </div>
    <template v-else>

      <v-app-bar app color="primary" dark v-if="$route.name =='select-account'">
        <div class="d-flex align-center">
          <v-img
            alt="Vuetify Logo"
            class="shrink mr-2"
            contain
            src="../../assets/logo-white.png"
            transition="scale-transition"
            width="25"
          />
        </div>
        <h2>Partner Portal</h2>
        <v-spacer></v-spacer>
        <v-btn v-if="isLoggedIn" @click="logout" text class="pa-0">
          <span class="mr-2">Logout</span>
          <v-icon>mdi-logout</v-icon>
        </v-btn>
      </v-app-bar>

      <v-app-bar app color="primary" dark v-else>
        <v-btn
          text
          v-if="activeAccount"
          @click="accountSelectionPage"
          ripple
          class="px-0"
        >
          <v-avatar tile v-bind:color=" activeAccount.type === 'reseller' ? 'rgb(188,188,255)' : 'rgb(255,255,255)' " size="32" class="rounded">
            <span class="primary--text">
              {{ activeAccount.code.substr(0, 2).toUpperCase() }}
            </span>
          </v-avatar>
          <span class="ml-2">{{ activeAccount.code.toUpperCase() }}</span>
        </v-btn>
        <v-spacer></v-spacer>      
        <v-chip
          class="ma-2"
          :color="activeAccount.rechargeTokensLeft > 0 ? 'green' : 'red'"
          outlined
          text-color="white"
          v-if="activeAccount.type == 'reseller'"
        >
          Tokens left: <b>{{ activeAccount.rechargeTokensLeft }}</b>
        </v-chip>
      </v-app-bar>

      <v-main>
        <v-container fluid style="padding-bottom: 4rem">
          <router-view />
        </v-container>
      </v-main>
      <v-bottom-navigation color="primary" grow fixed>
        <v-btn to="/partner/select-account">
          <span>Select Account</span>
          <v-icon>mdi-view-dashboard</v-icon>
        </v-btn>

        <v-btn to="/partner/customer">
          <span>Customer</span>
          <v-icon>mdi-account-search-outline</v-icon>
        </v-btn>

        <v-btn to="/partner/home">
          <span>Partner Home</span>
          <v-icon>mdi-credit-card-outline</v-icon>
        </v-btn>

        <v-btn to="/partner/businesses">
          <span>Businesses</span>
          <v-icon>mdi-format-list-bulleted-square</v-icon>
        </v-btn>

        <!-- <v-btn to="/partner/more">
          <span>More</span>
          <v-icon>mdi-key</v-icon>
        </v-btn>-->

        <v-btn @click="openChat('Support')">
          <span>Support</span>
          <v-icon>mdi-message</v-icon>
        </v-btn>
      </v-bottom-navigation>
    </template>
  </v-app>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import Snackbar from "../../components/Snackbar.vue";
import firebase from "../../firebase";
export default {
  name: "partner",
  components: { Snackbar },
  computed: {
    ...mapGetters({
      isLoggedIn: "user/isLoggedIn",
      isAccountsFetchWaiting: "partner/isFetchWaiting",
      activeAccount: "partner/active",
      businessList: "business/businessList",
      customerEmail: "customer/customerEmail",
    }),
  },
  watch: {
    async activeAccount(val) {
      if (!val) {
        this.$router.replace("/select-account");
      } else {
        await this.fetchAccountData(this.activeAccount);
      }
    },
  },
  methods: {
    ...mapActions({
      fetchAccountData: "partner/fetchAccountData",
      clearAccountData: "partner/clearAccountData",
      clearCustomer: "customer/clearCustomer",
    }),
    accountSelectionPage() {
      this.$router.push("/partner/select-account");
    },    
    customerPage() {
      this.clearCustomer();
      this.$router.replace("/partner/customer");
    },
    openChat(pageName) {
      // if (window.HelpCrunch) {
      //   window.HelpCrunch("updateUserData", {
      //     currentPage: pageName,
      //   });
      //   window.HelpCrunch("openChat");
      // }
      console.log(pageName);
    },
    logout () {
      firebase.auth().signOut()
    }
  },
  async created() {
    // Ensure data is fetched and data matches current selected account
    if (this.activeAccount) {
      await this.fetchAccountData(this.activeAccount);
    }
  },
  beforeDestroy() {
    this.clearAccountData();
  },
};
</script>

<style>
.loader-center {
  text-align: center;
  padding: 8rem 0;
}

.container--fluid {
  max-width: 1366px;
}
</style>
